// src/components/Sidebar/hooks/useEventActive.js
import { useEffect, useState } from "react";
import api from "../../../api/axios";

export default function useEventActive(endpoint) {
    const [active, setActive] = useState(false);

    useEffect(() => {
        let mounted = true;
        api
            .get(endpoint)
            .then((r) => mounted && setActive(!!r.data))
            .catch(() => mounted && setActive(false));

        return () => {
            mounted = false;
        };
    }, [endpoint]);

    return active;
}
